import { render } from "./red-envelop-2.vue?vue&type=template&id=4b56f39e&scoped=true&ts=true"
import script from "./red-envelop-2.vue?vue&type=script&lang=ts"
export * from "./red-envelop-2.vue?vue&type=script&lang=ts"

import "./red-envelop-2.vue?vue&type=style&index=0&id=4b56f39e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b56f39e"]])

export default __exports__